import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PatientConsentFormComponent } from './patient-consent-form/patient-consent-form.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {MatCardModule} from '@angular/material/card';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ProfileComponent } from './profile/profile.component';
import { MatButtonModule } from '@angular/material/button';
import { LetterheadComponent } from './letterhead/letterhead.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatRadioModule} from '@angular/material/radio';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import * as moment from 'moment';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { SearchPatientComponent } from './search-patient/search-patient.component';
import { AppointmentFormComponent } from './appointment-form/appointment-form.component';
import { CancelDialogComponent } from './cancel-dialog/cancel-dialog.component';
import { CalendarComponent } from './calendar/calendar.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatSliderModule} from '@angular/material/slider';
import { CameraComponent } from './camera/camera.component';
import { ProfilePictureDialogComponent } from './profile-picture-dialog/profile-picture-dialog.component';
import { WebcamModule } from 'ngx-webcam';
import { AppointmentsDialogComponent } from './appointments-dialog/appointments-dialog.component';
import { SearchLocationComponent } from './search-location/search-location.component';
import { LocationComponent } from './location/location.component';
import { MapComponent } from './map/map.component';
import { HttpClientModule } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { PractitionerComponent } from './practitioner/practitioner.component';
import { SearchPractitionerComponent } from './search-practitioner/search-practitioner.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { AlbumDialogComponent } from './album-dialog/album-dialog.component';
import {MatDividerModule} from '@angular/material/divider';
import { ServiceComponent } from './service/service.component';
import { SearchServiceComponent } from './search-service/search-service.component';

export function momentAdapterFactory() {
  return adapterFactory(moment);
};

@NgModule({
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    HttpClientModule
  ],
  declarations: [
    PatientConsentFormComponent,
    SignaturePadComponent,
    ProfileComponent,
    LetterheadComponent,
    CancelDialogComponent,
    CalendarComponent,
    AppointmentFormComponent,
    SearchPatientComponent,
    CameraComponent,
    ProfilePictureDialogComponent,
    CameraComponent,
    AppointmentsDialogComponent,
    SearchLocationComponent,
    LocationComponent,
    MapComponent,
    PractitionerComponent,
    SearchPractitionerComponent,
    AlbumDialogComponent,
    ServiceComponent,
    SearchServiceComponent
  ],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, MatCheckboxModule, FontAwesomeModule, MatCardModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatToolbarModule, MatProgressSpinnerModule, MatStepperModule, MatExpansionModule, MatRadioModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: momentAdapterFactory }), MatSnackBarModule, MatProgressBarModule, MatDatepickerModule, MatNativeDateModule, MatSliderModule, WebcamModule, HttpClientModule, GoogleMapsModule, MatSidenavModule, MatSelectModule, MatChipsModule, MatDividerModule
  ],
  exports: [
    PatientConsentFormComponent,
    ProfileComponent,
    CalendarComponent,
    AppointmentFormComponent,
    SearchPatientComponent,
    SearchLocationComponent,
    SearchPractitionerComponent,
    CameraComponent,
    LocationComponent,
    MapComponent,
    PractitionerComponent,
    ServiceComponent,
    SearchServiceComponent
  ]
})
export class SharedModule { }
